import FxCard from './Card';

export default FxCard;
